import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const RelatedPosts = ({ posts, currentPostId }) => {
  const navigate = useNavigate();

  const filteredPosts = posts?.filter(post => post?.id !== currentPostId);

  const handlePostClick = (postId) => {
    navigate(`/post-details?id=${postId}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (filteredPosts?.length === 0) {
    return null;
  }

  return (
    <div className="bg-card border-t border-border p-4 md:p-6">
      <h3 className="text-h5 font-heading mb-4 md:mb-6">
        More from this user
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-4">
        {filteredPosts?.slice(0, 6)?.map((post) => (
          <button
            key={post?.id}
            onClick={() => handlePostClick(post?.id)}
            className="relative aspect-square rounded-lg overflow-hidden group bg-muted"
            aria-label={`View post: ${post?.caption}`}
          >
            <Image
              src={post?.mediaUrl}
              alt={post?.mediaAlt}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
            />

            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-base flex items-center justify-center opacity-0 group-hover:opacity-100">
              <div className="flex items-center gap-4 text-white">
                <div className="flex items-center gap-1.5">
                  <Icon name="Heart" size={20} fill="white" />
                  <span className="caption font-medium">
                    {post?.likes > 999 ? `${(post?.likes / 1000)?.toFixed(1)}k` : post?.likes}
                  </span>
                </div>
                <div className="flex items-center gap-1.5">
                  <Icon name="MessageCircle" size={20} fill="white" />
                  <span className="caption font-medium">
                    {post?.comments > 999 ? `${(post?.comments / 1000)?.toFixed(1)}k` : post?.comments}
                  </span>
                </div>
              </div>
            </div>

            {post?.mediaType === 'video' && (
              <div className="absolute top-2 right-2 w-6 h-6 bg-black/70 rounded-full flex items-center justify-center">
                <Icon name="Play" size={14} color="white" fill="white" />
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default RelatedPosts;